import { connect, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import ShortUniqueId from 'short-unique-id';
import {
  updatecfObjectOptions,
  updatecfObjectOptions1,
} from '../../../redux/ChartPoperties/ChartControlsActions';

import { Button, FormControl, MenuItem, Select, Tooltip } from '@mui/material';
import {
  CustomFontAndBgColor,
  GetInputField,
  StyleButtons,
  conditionTypes,
} from '../CommonComponents';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { SelectComponentStyle, menuItemStyle } from '../Labels/SnakeyLabelOptions';
import './tablechartCF.css';
import { getContrastColor, generateRandomColorArray } from '../../CommonFunctions/CommonFunctions';
import { RootState } from '../../../redux';
import useCombinedColorSchemes from '../../../hooks/useCombinedColorSchemes';
import { useMemo, useEffect } from 'react';

const RuleComponent = ({ format, i, iconColor, backgroundColor }: any) => {
  const { chartControls, tabTileProps } = useSelector((state: RootState) => ({
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
  }));

  const dispatch = useDispatch();
  const uId = new ShortUniqueId({ length: 8 });

  const combinedThemes = useCombinedColorSchemes();
  const tabId = useSelector((state: RootState) => state.tabTileProps.selectedTabId);
  const defaultThemeId = useSelector(
    (state: RootState) => state.tabState.tabs[tabId]?.dashboardState.defaultThemeId,
  );

  const defaultThemeName = useMemo(() => {
    let theme = defaultThemeId
      ? combinedThemes.find((t) => t.id === defaultThemeId || t.themeId === defaultThemeId)
      : undefined;

    if (!theme && combinedThemes.length > 0) {
      theme = combinedThemes[0];
    }

    return theme?.name;
  }, [defaultThemeId, combinedThemes]);

  const propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  const chartControl: any = chartControls.properties[propKey];

  // Updated colors array based on theme
  const colors = useMemo(() => {
    const themeName = chartControl.colorScheme || defaultThemeName || 'peacock';
    let theme = combinedThemes.find((t) => t.name === themeName);
    if (!theme) {
      theme = combinedThemes.find((t) => t.name === 'peacock');
    }
    const randomColors = generateRandomColorArray(15);
    return [...(theme?.colors || []), ...randomColors];
  }, [chartControl.colorScheme, defaultThemeName, combinedThemes]);

  // Update existing rules' colors when theme changes
  // useEffect(() => {
  //   if (!format?.value) return;

  //   const updatedRules = format.value.map((rule: any, idx: number) => ({
  //     ...rule,
  //     backgroundColor: colors[idx % colors.length],
  //     fontColor: getContrastColor(colors[idx % colors.length]),
  //   }));

  //   dispatch(
  //     updatecfObjectOptions1(
  //       propKey,
  //       chartControls.properties[propKey].tableConditionalFormats.map((col: any) => {
  //         if (col.name === format.name) return { ...col, value: updatedRules };
  //         return col;
  //       }),
  //     ),
  //   );
  // }, [colors]);

  const onUpdateRule = (updatedArray: any, columnName: string) => {
    const updatedValues = chartControls.properties[propKey].tableConditionalFormats.map(
      (column: any) => {
        if (column.name === columnName) {
          return {
            ...column,
            value: updatedArray.map((rule: any) =>
              rule.conditionType === 7
                ? { ...rule, target: 'between' }
                : { ...rule, target: rule.target === 'between' ? rule.minValue : rule.target },
            ),
          };
        }
        return column;
      },
    );
    dispatch(updatecfObjectOptions1(propKey, updatedValues));
  };

  const onAddCondition = (format: any, index: number) => {
    const ruleCount = format.value?.length || 0;
    const color = colors[ruleCount % colors.length];

    const obj = {
      id: uId(),
      isConditionSatisfied: false,
      conditionType: 1,
      target: null,
      minValue: null,
      maxValue: null,
      backgroundColor: color,
      fontColor: getContrastColor(color),
      isBold: false,
      isItalic: false,
      isUnderlined: false,
      isCollapsed: true,
    };

    dispatch(
      updatecfObjectOptions(propKey, index, {
        ...format,
        value: [...format.value, obj],
      }),
    );
  };

  const onStylePropsChange = (id: string, option: string, value: any) => {
    const updatedArray = format.value.map((el: any) => {
      if (el.id === id) {
        const updated = { ...el, [option]: value };

        // Mark as color changed if user manually updates background or font color
        if (option === 'backgroundColor' || option === 'fontColor') {
          updated.isColorChanged = true;
        }

        return updated;
      }
      return el;
    });
    onUpdateRule(updatedArray, format.name);
  };

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {format.value.map((condition: any, idx: number) => {
          return (
            <div
              key={condition.idx}
              style={{
                display: 'flex',
                flexDirection: 'column',
                borderBottom: '2px solid rgba(224,224,224,1)',
                paddingBottom: '10px',
              }}
            >
              <div style={{ display: 'flex', marginTop: '5px' }}>
                <span style={{ color: iconColor }}>Rule {idx + 1}</span>
                <span
                  className="deleteIconContainer"
                  style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}
                >
                  <Tooltip
                    title="Reset Rule"
                    slotProps={{
                      tooltip: {
                        sx: {
                          fontSize: '12px',
                        },
                      },
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="lucide lucide-eraser-icon lucide-eraser"
                      color={iconColor ? iconColor : 'currentColor'}
                      onClick={() => {
                        const filterdArray = format.value.filter((el: any) => {
                          return el.id !== condition.id;
                        });
                        onUpdateRule(filterdArray, format.name);
                      }}
                    >
                      <path d="M21 21H8a2 2 0 0 1-1.42-.587l-3.994-3.999a2 2 0 0 1 0-2.828l10-10a2 2 0 0 1 2.829 0l5.999 6a2 2 0 0 1 0 2.828L12.834 21" />
                      <path d="m5.082 11.09 8.828 8.828" />
                    </svg>
                  </Tooltip>
                </span>
                <span
                  className="expandLessMoreContainer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: 'unset',
                    fontSize: '18px',
                  }}
                >
                  {condition.isCollapsed ? (
                    <ExpandMoreIcon
                      sx={{
                        fontSize: '16px',
                        color: iconColor,
                      }}
                      onClick={() => {
                        onStylePropsChange(condition.id, 'isCollapsed', !condition.isCollapsed);
                      }}
                    />
                  ) : (
                    <ChevronRightIcon
                      sx={{
                        fontSize: '16px',
                        color: iconColor,
                      }}
                      onClick={() =>
                        onStylePropsChange(condition.id, 'isCollapsed', !condition.isCollapsed)
                      }
                    />
                  )}
                </span>
              </div>

              {condition.isCollapsed && (
                <div style={{ flexDirection: 'column' }}>
                  <div style={{ color: iconColor }}>Condition</div>
                  <FormControl
                    fullWidth
                    size="small"
                    style={{ fontSize: '12px', borderRadius: '4px', marginTop: '5px' }}
                  >
                    <Select
                      value={condition.conditionType}
                      variant="outlined"
                      onChange={(e) =>
                        onStylePropsChange(condition.id, 'conditionType', e.target.value)
                      }
                      sx={{
                        ...SelectComponentStyle,
                        color: iconColor,

                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: iconColor,
                        },
                        width: '100% !important',
                        margin: '0 auto 0.5rem auto !important',
                      }}
                    >
                      {conditionTypes.map((item: any) => (
                        <MenuItem
                          value={item.id}
                          key={item.id}
                          sx={{ textTransform: 'capitalize', ...menuItemStyle }}
                        >
                          {item.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <GetInputField
                    iconColor={iconColor}
                    backgroundColor={backgroundColor}
                    condition={condition}
                    onChangeValueProps={(option: string, value: any) =>
                      onStylePropsChange(condition.id, option, value)
                    }
                  />

                  <div
                    style={{
                      display: 'flex',
                      marginTop: '5px',
                      marginLeft: '0px',
                      justifyContent: 'center',
                    }}
                  >
                    <StyleButtons
                      isBold={condition.isBold}
                      isItalic={condition.isItalic}
                      isUnderlined={condition.isUnderlined}
                      onChangeStyleProps={(option: string, value: any) =>
                        onStylePropsChange(condition.id, option, value)
                      }
                      iconColor={iconColor}
                    />
                    <CustomFontAndBgColor
                      backgroundColor={condition.backgroundColor}
                      fontColor={condition.fontColor}
                      onChangeColorProps={(option: string, color: any, id: any) =>
                        onStylePropsChange(id, option, color)
                      }
                      id={condition.id}
                    />
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <Button
        sx={{
          backgroundColor: 'rgb(43, 185, 187)',
          height: '25px',
          width: '100%',
          color: 'white',
          textTransform: 'none',
          '&:hover': { backgroundColor: 'rgb(43, 185, 187)' },
        }}
        onClick={() => onAddCondition(format, i)}
      >
        Add Rule
      </Button>

      <div>
        <p className="noteStyle" style={{ color: iconColor }}>
          *Conditional formatting overrides any existing formatting applied*
        </p>
      </div>
    </div>
  );
};

export default RuleComponent;
